import useSentry from '../sentry/hooks/useSentry';
import useMfeEvents from '../mfeEvents/hooks/useMfeEvents';

const useServices = () => {
  useSentry();
  useMfeEvents();
};

export default useServices;
